import React, { useContext } from 'react';
import { UserContext } from '../functions/Auth';

// components
import RoomCard from '../components/RoomCard';

// mui
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

export default function Home() {
    const userInfo = useContext(UserContext);

    return (
        <Box>
            {/*ルーム*/}
            <List>
                {userInfo?.rooms.map((room) => (
                    <ListItem
                        key={room.roomId}
                        disablePadding
                        sx={{
                            pt: 1,
                            px: 0,
                            pb: 0,
                            [`&:first-of-type`]: {
                                pt: 0,
                            }
                        }}
                    >
                        <RoomCard
                            description={room.description}
                            memberCount={room.memberCount}
                            name={room.name}
                            roomId={room.roomId}
                            thumbnailUrl={room.thumbnailUrl}
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}